export default "/images/vendor/chocolat/dist/fullscreen.png?69f0ac126e79f5416d4cf96d92c743fa";